module.exports = "pegasus/assets/square-youtube.gif";